export default "__VITE_ASSET__BiwjMpjg__"